import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  GET_ALL_HIRING,
  DELETE_SINGLE_HIRING,
  GET_SINGLE_HIRING,
} from "./actionTypes";

import {
  getAllHiringApi,
  deleteSingleHiringApi,
  getSingleHiringApi,
} from "api/hiring";

import {
  getAllHiringSuccess,
  getAllHiringFailure,
  deleteSingleHiringSuccess,
  deleteSingleHiringFailure,
  getSingleHiringSuccess,
  getSingleHiringFailure,
} from "./actions";
import { toastErrorMessageNew } from "helpers/toaster/toastErrorMessageNew";

// api calls
function* getAllHiring() {
  try {
    const { data } = yield call(getAllHiringApi);

    yield put(getAllHiringSuccess(data));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(getAllHiringFailure(error.response?.data?.message || error));
  }
}

function* getSingleHiring({ payload }) {
  try {
    const { data } = yield call(getSingleHiringApi, payload);

    yield put(getSingleHiringSuccess(data));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(getSingleHiringFailure(error.response?.data?.message || error));
  }
}

function* deleteSingleHiring({ payload }) {
  try {
    yield call(deleteSingleHiringApi, payload);
    yield put(deleteSingleHiringSuccess(payload));
  } catch (error) {
    toastErrorMessageNew({ error: error?.response?.data });

    yield put(deleteSingleHiringFailure(error));
  }
}

// watchers
export function* watchgetAllHiring() {
  yield takeEvery(GET_ALL_HIRING, getAllHiring);
}

export function* watchgetSingleHiring() {
  yield takeEvery(GET_SINGLE_HIRING, getSingleHiring);
}

export function* watchDeleteSingleHiring() {
  yield takeEvery(DELETE_SINGLE_HIRING, deleteSingleHiring);
}

function* hiringSaga() {
  yield all([
    fork(watchgetAllHiring),
    fork(watchgetSingleHiring),
    fork(watchDeleteSingleHiring),
  ]);
}

export default hiringSaga;
